export default "/images/63c341cb38040460442f338e8aa63539.avif";